export default "__VITE_ASSET__Dpy3d3JF__"